import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
  class: "filter"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "button button-grey filter-button"
}, [/*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.2876 3.5H16.7119C16.9783 3.5 17.2389 3.57738 17.4622 3.72272C17.6854 3.86807 17.8616 4.07513 17.9694 4.31874C18.0771 4.56235 18.1118 4.83201 18.0692 5.09496C18.0266 5.35791 17.9085 5.60282 17.7293 5.79992L12.6248 11.415V15.7905C12.6248 16.0169 12.5689 16.2397 12.4621 16.4393C12.3552 16.6389 12.2008 16.809 12.0125 16.9346L9.51247 18.6012C9.30539 18.7393 9.06473 18.8186 8.81614 18.8306C8.56756 18.8426 8.32037 18.7869 8.10095 18.6695C7.88152 18.552 7.69808 18.3773 7.57019 18.1638C7.4423 17.9503 7.37475 17.7061 7.37475 17.4572V11.415L2.27018 5.79992C2.09099 5.60282 1.97292 5.35791 1.93031 5.09496C1.88769 4.83201 1.92238 4.56235 2.03014 4.31874C2.13791 4.07513 2.31411 3.86807 2.53734 3.72272C2.76057 3.57738 3.02122 3.5 3.2876 3.5ZM3.57017 5H16.4293L11.4823 10.4417C11.2522 10.6948 11.1248 11.0246 11.1248 11.3666V15.7236L8.87475 17.2236V11.3666C8.87475 11.0246 8.74726 10.6948 8.51717 10.4417L3.57017 5Z",
  fill: "black"
})]), /*#__PURE__*/_createTextVNode(" Фильтр ")], -1);

const _hoisted_3 = {
  class: "filter-block"
};
const _hoisted_4 = {
  class: "filter-top"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "filter-title"
}, "Фильтр", -1);

const _hoisted_6 = {
  href: "#filter-author",
  class: "filter-link"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Авторы ");

const _hoisted_8 = {
  key: 0,
  class: "filter-num active"
};
const _hoisted_9 = {
  href: "#filter-year",
  class: "filter-link"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Год ");

const _hoisted_11 = {
  key: 0,
  class: "filter-num active"
};
const _hoisted_12 = {
  class: "filter-bottom"
};
const _hoisted_13 = {
  class: "filter-second",
  id: "filter-author"
};
const _hoisted_14 = {
  class: "filter-top"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "filter-back"
}, "Авторы", -1);

const _hoisted_16 = {
  class: "search"
};
const _hoisted_17 = {
  class: "filter-scroll"
};
const _hoisted_18 = {
  class: "filter-letter"
};
const _hoisted_19 = {
  class: "filter-list"
};
const _hoisted_20 = ["value", "id"];
const _hoisted_21 = ["for"];
const _hoisted_22 = {
  class: "filter-bottom"
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Выбрать ");

const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  class: "filter-second",
  id: "filter-year"
};
const _hoisted_26 = {
  class: "filter-top"
};

const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "filter-back"
}, "Год", -1);

const _hoisted_28 = {
  class: "search"
};

const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  class: "search-button",
  style: {
    "cursor": "pointer"
  }
}, null, -1);

const _hoisted_30 = {
  class: "filter-scroll"
};
const _hoisted_31 = {
  class: "filter-list"
};
const _hoisted_32 = ["id", "value"];
const _hoisted_33 = ["for"];
const _hoisted_34 = {
  class: "filter-bottom"
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Выбрать ");

const _hoisted_36 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("a", {
    class: "filter-clear",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.resetWorksFilter && $options.resetWorksFilter(...args))
  }, "Сбросить все")]), _createElementVNode("a", _hoisted_6, [_hoisted_7, this.WorksFilter.authors.selected.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(this.WorksFilter.authors.selected.length), 1)) : _createCommentVNode("", true)]), _createElementVNode("a", _hoisted_9, [_hoisted_10, this.WorksFilter.years.selected.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(this.WorksFilter.years.selected.length), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
    class: "button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.emitFilter && $options.emitFilter(...args))
  }, "Применить фильтр")])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("a", {
    class: "filter-clear",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $options.resetWorksFilterAuthors && $options.resetWorksFilterAuthors(...args))
  }, "Сбросить")]), _createElementVNode("div", _hoisted_16, [_createElementVNode("label", null, [_withDirectives(_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => this.WorksFilter.authors.search = $event),
    onChange: _cache[4] || (_cache[4] = (...args) => $options.searchAuthors && $options.searchAuthors(...args))
  }, null, 544), [[_vModelText, this.WorksFilter.authors.search]])]), _createElementVNode("button", {
    class: "search-button",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[5] || (_cache[5] = (...args) => $options.searchAuthors && $options.searchAuthors(...args))
  })]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.formattedFilterAuthors, (items, key) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: key
    }, [_createElementVNode("div", _hoisted_18, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "check-item",
        key: item.id
      }, [_withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "check-input",
        value: item.id,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.WorksFilter.authors.selected = $event),
        id: 'ch' + item.id
      }, null, 8, _hoisted_20), [[_vModelCheckbox, $data.WorksFilter.authors.selected]]), _createElementVNode("label", {
        for: 'ch' + item.id,
        class: "check-label"
      }, _toDisplayString(item.name), 9, _hoisted_21)]);
    }), 128))])], 64);
  }), 128))]), _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
    class: "button",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.emitFilter && $options.emitFilter(...args))
  }, [_hoisted_23, this.WorksFilter.authors.selected.length ? (_openBlock(), _createElementBlock("span", _hoisted_24, " (" + _toDisplayString(this.WorksFilter.authors.selected.length) + ") ", 1)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("a", {
    class: "filter-clear",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[8] || (_cache[8] = (...args) => $options.resetWorksFilterYears && $options.resetWorksFilterYears(...args))
  }, "Сбросить")]), _createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => this.WorksFilter.years.search = $event)
  }, null, 512), [[_vModelText, this.WorksFilter.years.search]]), _hoisted_29]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.formattedFilterYears, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "check-item",
      key: index
    }, [_withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "check-input",
      id: 'ch-yeats-' + index,
      value: item,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.WorksFilter.years.selected = $event)
    }, null, 8, _hoisted_32), [[_vModelCheckbox, $data.WorksFilter.years.selected]]), _createElementVNode("label", {
      for: 'ch-yeats-' + index,
      class: "check-label"
    }, _toDisplayString(item), 9, _hoisted_33)]);
  }), 128))])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("button", {
    class: "button",
    onClick: _cache[11] || (_cache[11] = (...args) => $options.emitFilter && $options.emitFilter(...args))
  }, [_hoisted_35, this.WorksFilter.years.selected.length ? (_openBlock(), _createElementBlock("span", _hoisted_36, " (" + _toDisplayString(this.WorksFilter.years.selected.length) + ") ", 1)) : _createCommentVNode("", true)])])])]);
}